import { ApplicationConfig, importProvidersFrom } from "@angular/core";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, provideHttpClient, withInterceptors } from "@angular/common/http";
import { provideRouter, withRouterConfig } from "@angular/router";
import { routerConfig, routes } from "./app.routes";
import { NgPipesModule } from "ngx-pipes";
import { DialogService } from "primeng/dynamicdialog";
import { cacheInterceptor } from "@shared/interceptors/cache-interceptor/cache-interceptor.interceptor";
import { provideNoopAnimations } from "@angular/platform-browser/animations";
import { httpLoaderFactory } from "@shared/factories/http-loader/http-loader.factory";
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';
import { MessageService } from "primeng/api";

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    provideRouter(routes, withRouterConfig(routerConfig)),
    provideHttpClient(withInterceptors([cacheInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Lara,
        options: {
          darkModeSelector: false || 'none',
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-base, primeng, tailwind-utilities'
          }
        }
      }
      // zIndex: {
      //   modal: 1100,    // dialog, sidebar
      //   overlay: 1000,  // dropdown, overlaypanel
      //   menu: 1000,     // overlay menus
      //   tooltip: 1100   // tooltip
      // }
    }),
    provideNoopAnimations(),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient]
        }
      }),
      NgPipesModule
    ),
    DialogService
  ]
}
